var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiners(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16,
    viewBox: "0 0 24 16",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m21.9972414 15.749927.0021396.0000092c.9550873.0081744 1.738679-.7726837 1.750619-1.7457807l.0000083-11.99785331c-.0038381-.47061298-.191145-.92013113-.5202786-1.24950041-.3282978-.3285329-.7708136-.51065293-1.2324883-.50673093l-19.9966114-.00000906c-.45954607-.00391294-.90206187.17820709-1.23035972.50673999-.32913363.32936928-.51644046.77888743-.52027028 1.24746158l-.00000831 11.98943234c.00383813.4706129.19114496.9201311.52027859 1.2495004.32829785.3285329.77081365.5106529 1.23248834.5067309zm-.0010384.5c-.0003671-.000003-.0007342-.000006-.0011012-.0000092l.0021396.0000092z",
    fill: "#fff",
    stroke: "#000",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.0021142 2.05179033v-.016h4v.016c3.1354339.22943885 5.5621141 2.84018253 5.5621141 5.984s-2.4266802 5.75456117-5.5621141 5.98399997v.016h-4v-.016c-3.13543399-.2294388-5.5621142-2.8401825-5.5621142-5.98399997s2.42668021-5.75456115 5.5621142-5.984z",
    fill: "#0165ac"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.6021142 11.4277903c1.435286-.5102876 2.3940414-1.86870107 2.3940414-3.39199997s-.9587554-2.88171241-2.3940414-3.392zm-2.40000003-6.78399997c-1.43528608.51028759-2.39404146 1.8687011-2.39404146 3.392s.95875538 2.88171237 2.39404146 3.39199997zm1.20000003 8.59199997c-2.87188073 0-5.20000003-2.3281193-5.20000003-5.19999997 0-2.8718807 2.3281193-5.2 5.20000003-5.2 2.8718807 0 5.2 2.3281193 5.2 5.2 0 2.87188067-2.3281193 5.19999997-5.2 5.19999997z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiners);
export default __webpack_public_path__ + "static/media/diners.1437b66867ec1edd8760fcd7ae868244.svg";
export { ForwardRef as ReactComponent };